import * as components from './components'

export default [
  {
    path: '/toolManagement',
    component: components.ToolList,
    name: 'toolList',
    props: true
  },
  {
    path: '/toolManagement/create',
    component: components.ToolCreate,
    name: 'toolCreate',
    props: true
  },
  {
    path: '/toolManagement/:uuid/edit',
    component: components.ToolCreate,
    name: 'toolEdit',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/tool/routes.js